import gql from 'graphql-tag'

export const eventCodeCreate = gql`
  mutation eventCodeCreate($data: EventCodeCreateInput!) {
    eventCodeCreate(input: $data) {
      success
    }
  }
`
